import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import VueGtag from "vue-gtag";

import "./assets/scss/global.scss";

createApp(App)
  .use(store)
  .use(router)
  .use(VueGtag, {
    config: { id: "G-JF5EFXB0VV" },
  })
  .mount("#app");
